import classes from './DailyForm.module.scss';
import { useTranslation } from 'react-i18next';
import { Calendar, CalendarProps } from 'primereact/calendar';
import { defaultCronObject, Props } from '../CrontabView';
import { useEffect } from 'react';

const DailyForm = ({ onCronChanged, date }: Props) => {

  const { t: translate } = useTranslation();

  useEffect(() => {
    onCronChanged({
      ...defaultCronObject,
      minutes: date.getMinutes().toString(),
      hours: date.getHours().toString()
    });
  }, []);

  const changeHandler = (select: CalendarProps) => {
    const tmpDate: Date = select.value as Date;
    onCronChanged({
      ...defaultCronObject,
      minutes: tmpDate.getMinutes().toString(),
      hours: tmpDate.getHours().toString(),
    });
  };

  return (
    <div className={ classes['form-control'] }>
      <label>{ translate('cron-tab.input.at') }</label>
      <Calendar
        showIcon
        showTime
        icon="pi pi-clock"
        timeOnly
        hourFormat="24"
        value={ date }
        onChange={ changeHandler }
      />
    </div>
  );
};

export default DailyForm;